"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPublicPurchaseService = void 0;
var purchase_v2_1 = require("./purchase.v2");
var purchase_v3_1 = require("./purchase.v3");
function createPublicPurchaseService(isV3, authorization, baseUrl) {
    return isV3
        ? new purchase_v3_1.PublicPurchaseServiceV3(authorization, baseUrl)
        : new purchase_v2_1.PublicPurchaseServiceV2();
}
exports.createPublicPurchaseService = createPublicPurchaseService;
//# sourceMappingURL=index.js.map